import axios from 'axios';
import { LessonImageFormat } from './courcesService';

const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';

export interface NewsImageType {
  id: number;
  documentId?: string;
  name?: string;
  alternativeText?: string | null;
  caption?: string | null;
  width?: number;
  height?: number;
  formats?: {
    thumbnail?: LessonImageFormat;
    small?: LessonImageFormat;
    medium?: LessonImageFormat;
    large?: LessonImageFormat;
  };
  hash?: string;
  ext?: string;
  mime?: string;
  size?: number;
  url: string;
  previewUrl?: string | null;
  provider?: string;
  provider_metadata?: any;
  folderPath?: string;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
  locale?: string | null;
}

export type GetNewsResponse = {
  id: number;
  documentId: string;
  title: string;
  description: string;
  link: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  locale: string | null;
  featuredImage: NewsImageType;
};

const absolutizeImageUrls = (img?: NewsImageType | null): NewsImageType | null | undefined => {
  if (!img) return img;
  const baseUrl = SERVER_URL.replace('/api', '');
  const absolutize = (url?: string) => (url && !url.startsWith('http') ? `${baseUrl}${url}` : url);
  const formats = img.formats ? {
    ...img.formats,
    thumbnail: img.formats.thumbnail ? { ...img.formats.thumbnail, url: absolutize(img.formats.thumbnail.url)! } : undefined,
    small: img.formats.small ? { ...img.formats.small, url: absolutize(img.formats.small.url)! } : undefined,
    medium: img.formats.medium ? { ...img.formats.medium, url: absolutize(img.formats.medium.url)! } : undefined,
    large: img.formats.large ? { ...img.formats.large, url: absolutize(img.formats.large.url)! } : undefined,
  } : undefined;
  return {
    ...img,
    url: absolutize(img.url)!,
    formats,
  };
};

export const getNewsFiltered = async (params: { filteredField?: 'title'; filteredValue?: string; sort?: 'asc' | 'desc'; pagination?: { page?: number; pageSize?: number } }): Promise<GetNewsResponse[]> => {
  const { filteredField, filteredValue, sort = 'desc', pagination } = params || {};
  try {
    const token = localStorage.getItem('jwt_token');

    const qs = new URLSearchParams();
    if (filteredField && filteredValue) {
      qs.set(`filters[${filteredField}][$containsi]`, String(filteredValue));
    }
    if (sort) {
      qs.set('sort', `updatedAt:${sort}`);
    }
    if (pagination?.page !== undefined) {
      qs.set('pagination[page]', String(pagination.page));
    }
    if (pagination?.pageSize !== undefined) {
      qs.set('pagination[pageSize]', String(pagination.pageSize));
    }

    const queryString = qs.toString();
    const url = `${SERVER_URL}/api/external-news${queryString ? `?${queryString}` : ''}`;

    const response = await axios.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const items: GetNewsResponse[] = response.data.data || response.data || [];
    return items.map((n) => ({
      ...n,
      featuredImage: absolutizeImageUrls(n.featuredImage) as NewsImageType,
    }));
  } catch (error) {
    throw error;
  }
};
